'use client'

import { message } from 'antd'
import { useEffect } from 'react'
import { messageTop as top } from '@/utils/settings'

message.config({
  top,
  maxCount: 1
})

export default function ErrorMessage({ error }: { error: string | undefined }) {
  useEffect(() => {
    if (error) {
      message.error(error)
    }
  }, [error])

  return null // 不渲染任何UI
}
